export enum CompanyServiceCode {
  ActiveTransfer = 'activeTransfer',
  Comparable = 'comparable',
  HomesIQ = 'homesIQ',
  XMLImport = 'xmlImport',
  Lasso = 'lasso',
  LeadForward = 'leadForward',
  LeaseListings = 'leaseListings',
  LotListings = 'lotListings',
  NewListing = 'newListing',
  PendingTransfer = 'pendingTransfer',
  RealtorIntel = 'realtorIntel',
  Relist = 'relist',
  ScraperImportListing = 'scraperImportListing',
  ScraperImportLease = 'scraperImportLease',
  ShowingTime = 'showingTime',
  SupraBox = 'supraBox',
  JsonImport = 'jsonImport'
}

export const CompanyServiceCodeLabel = new Map<CompanyServiceCode, string>([
  [CompanyServiceCode.ActiveTransfer, 'Active Transfer'],
  [CompanyServiceCode.Comparable, 'Comparable'],
  [CompanyServiceCode.HomesIQ, 'Homes IQ'],
  [CompanyServiceCode.XMLImport, 'XML Import'],
  [CompanyServiceCode.Lasso, 'Lasso'],
  [CompanyServiceCode.LeadForward, 'Lead Forward'],
  [CompanyServiceCode.LeaseListings, 'Lease Listings'],
  [CompanyServiceCode.LotListings, 'Lot Listings'],
  [CompanyServiceCode.NewListing, 'New Listing'],
  [CompanyServiceCode.PendingTransfer, 'Pending Transfer'],
  [CompanyServiceCode.RealtorIntel, 'Realtor Intel'],
  [CompanyServiceCode.Relist, 'Relist'],
  [CompanyServiceCode.ScraperImportListing, 'Scraper Import Listing'],
  [CompanyServiceCode.ScraperImportLease, 'Scraper Import Lease'],
  [CompanyServiceCode.ShowingTime, 'ShowingTime'],
  [CompanyServiceCode.SupraBox, 'SupraBox'],
  [CompanyServiceCode.JsonImport, 'Json Import']
]);
